/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-26 17:33:22
 * @LastEditTime: 2022-01-26 20:34:56
 * @LastEditors: zhao - 🍉
 * @Description: 租金宝同步数据 - 楼栋详情
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/components/BuildingDetailListModal.jsx
 */
import { Button, Modal } from 'antd'
import React, { useState, forwardRef, useImperativeHandle } from 'react'
import ModalScrollContainer from "../../../components/ModalScrollContainer";
import TableHelper from '../../../components/TableHelper'
import TableNewlineView from "../../../components/TableNewlineView";
import { fetchZJBSyncDataBuildingInfo } from '../../../services/ZJBSyncDataRecord'
import { commonIsMap, dicRecvCertType, mapZJBSyncDataDetailType } from "../../../axios/dictionaries";
import { findDict, formatTime } from '../../../utils';


const BuildingDetailListModal = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const [defaultSearch, setDefaultSearch] = useState(null);
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (operationType, syncDate) => {
        setVisible(true)
        setDefaultSearch({ operationType, syncStartDate: syncDate, syncEndDate: syncDate })
    }
    const close = () => {
        setVisible(false)
        setDefaultSearch(null)
    }
    const columns = [
        { title: '小区/楼栋名称', dataIndex: 'name', width: 200 },
        { title: '地址', dataIndex: 'province', width: 230, render: (text, record) => {
            const province = [record.province, record.city, record.area].filter(e => !!e).join('-')
            return <TableNewlineView >
                {[province, record.address]}
            </TableNewlineView>
        } },
        { title: '账户账号', dataIndex: 'balanceAcc', },
        { title: '开户行网点号', dataIndex: 'balanceAccBankNo', },
        { title: '账户户名', dataIndex: 'balanceAccName', },
        { title: '租赁期限起始日', dataIndex: 'beginDate', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '租赁期限截止日', dataIndex: 'endDate', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '房源id', dataIndex: 'buildingNo', },
        { title: '是否清算', dataIndex: 'clarify', render: (text) => {
            return findDict(commonIsMap,text).title
        }},
        { title: '承租押金', dataIndex: 'depositAmt', },
        { title: '层高', dataIndex: 'floorCount'},
        { title: '收房合同名称', dataIndex: 'houseContractName', width: 160, render: (text, record) => {
            return <a href={record.houseContractUrl} download >{text}</a>
        } },

        { title: '区域Code', dataIndex: 'jrAreaId', },
        { title: '建融公寓小区地址', dataIndex: 'jrCommunityAddress', },
        { title: '建融公寓小区名称', dataIndex: 'jrCommunityName', },
        // { title: '小区在地图中的经度信息（百度坐标）', dataIndex: 'jrLatitude', },
        // { title: '小区在地图中的纬度信息（百度坐标）', dataIndex: 'jrLongitude', },
    
        { title: '商户', dataIndex: 'merchantName', },
        { title: '是否参与商户对账', dataIndex: 'merchantReconciliation', render: (text) => {
            return findDict(commonIsMap,text).title
        }},
       
        { title: '承租月租金', dataIndex: 'payAmtByMonth', },
  
        { title: '业主证件号码', dataIndex: 'recvCertNo', },
        { title: '业主证件类型', dataIndex: 'recvCertType', render: (text) => {
            return findDict(dicRecvCertType, text).title
        } },
        { title: '业主名称', dataIndex: 'recvName', },
        { title: '商户简称', dataIndex: 'shortName', },
        { title: '创建时间', dataIndex: 'createTime', render: (text) => formatTime(text, 'YYYY-MM-DD')},
        { title: '编辑时间', dataIndex: 'updateTime', render: (text) => formatTime(text, 'YYYY-MM-DD')}
    ]

    const searchOptions = [
        { key: 'operationType', type: 'select', options: mapZJBSyncDataDetailType },
        { key: 'syncStartDate', type: 'date', placeholder: '同步开始日期' },
        { key: 'syncEndDate', type: 'date', placeholder: '同步结束日期' },
    ]
    return (
        <Modal visible={visible} title="楼栋详情" width={950} destroyOnClose onCancel={close} footer={<Button onClick={close}>关闭</Button>}>
            {
                (visible && defaultSearch) && (
                    <ModalScrollContainer>
                        <TableHelper 
                            initialValue={defaultSearch} 
                            columns={columns} 
                            searchOptions={searchOptions} 
                            scroll={{ x: 3000 }}
                            request={fetchZJBSyncDataBuildingInfo} 
                        />
                    </ModalScrollContainer>
                )
            }
        </Modal>
    )
}

export default forwardRef(BuildingDetailListModal)


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/components/BuildingDetailListModal.jsx